import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { toast } from 'sonner';
import { BaseModal } from 'wbs-components-lib';

import { BetOutcomeModel } from '@shared/types';

import { useCreateBetOutcomeMutation } from '@services';

import { AppDispatch, setBetOutcome } from '@store';

import { BetOutcomeForm, BetOutcomeFormValues, INITIAL_BET_OUTCOME_VALUES } from '../../../BetSystemSettingsForms';

import { BetOutcomeCreateModalProps } from './types';

export const BetOutcomeCreateModal: FC<BetOutcomeCreateModalProps> = ({ isOpened, handleClose, betEventId }) => {
  const dispatch = useDispatch<AppDispatch>();

  const [createBetOutcome, { isLoading: isCreatingInProgress }] = useCreateBetOutcomeMutation();

  const handleCreateBetOutcome = async (values: BetOutcomeFormValues) => {
    const createdBetOutcome = await createBetOutcome({
      ...values,
      eventId: betEventId,
    } as unknown as Omit<BetOutcomeModel, 'resultType' | 'bettors'>).unwrap();

    dispatch(setBetOutcome(createdBetOutcome));

    toast.success('Success: Bet outcome has been created!');

    handleClose();
  };

  return (
    <BaseModal headerTitle="Create Outcome" isOpened={isOpened} handleClose={handleClose} isFooterNeeded={false}>
      <BetOutcomeForm
        initialValues={INITIAL_BET_OUTCOME_VALUES}
        isSubmitting={isCreatingInProgress}
        onSubmit={handleCreateBetOutcome}
      />
    </BaseModal>
  );
};
